import { render, staticRenderFns } from "./mdEditorForPrice.vue?vue&type=template&id=aa32a22a&scoped=true&"
import script from "./mdEditorForPrice.vue?vue&type=script&lang=js&"
export * from "./mdEditorForPrice.vue?vue&type=script&lang=js&"
import style0 from "./mdEditorForPrice.vue?vue&type=style&index=0&id=aa32a22a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa32a22a",
  null
  
)

export default component.exports